import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { authAxios as axios, useAuth } from "shared-auth";
import { HALManager } from "core";
import { useErrorBoundary } from "component-library";
import { IProfileViewResponse } from "models";
import { getApiUrl } from "services/UrlBuilder";
import { usePublicView } from "pages/Profile/hooks/usePublicView";

export const profileViewPinQueryKey = "profileViewPinQueryKey";

export function useGetPublicProfile() {
  const captureError = useErrorBoundary();
  const auth = useAuth();
  const { viewPin, isPublicView } = usePublicView();

  return useQuery<IProfileViewResponse, AxiosError>(
    [profileViewPinQueryKey, viewPin, auth.isAuthenticated],
    async () => {
      const urlRequest = getApiUrl(HALManager.getProfileByViewPinUrl(viewPin));
      const { data } = await axios.get(urlRequest);

      return data;
    },
    {
      enabled: isPublicView,
      cacheTime: 0,
      onError: captureError,
    }
  );
}
